import React from 'react';
import { motion } from 'framer-motion';
import { riseIn } from '../motion';
import type { Tone } from './ActionTile';

interface Props {
  icon: React.ReactNode;
  tone?: Tone;
  title: string;
  action?: React.ReactNode;
}

/** 空のときは、次にやることだけを置く。アイコンがふわふわ浮く。 */
export const EmptyState: React.FC<Props> = ({ icon, tone = 'primary', title, action }) => (
  <motion.div className="v2-empty" variants={riseIn} initial="hidden" animate="show">
    <motion.span
      className={`v2-empty-icon v2-tone--${tone}`}
      animate={{ y: [0, -6, 0] }}
      transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
    >
      {icon}
    </motion.span>
    <span className="v2-empty-title">{title}</span>
    {action}
  </motion.div>
);
